import { createSlice } from '@reduxjs/toolkit';
import { getUserSchema } from '../../../helpers/general-helpers';
import { getValueOrDefault } from '../../../helpers/getvalueOrDefault';
import type { RootState } from '../../store';

export interface GlobalFilterQuickDateRange {
  value: string | number;
  text: string;
}

export interface GlobalFilterDateDetails {
  dateEnd: string;
  dateStart: string;
  quickDateRange: GlobalFilterQuickDateRange;
}

export interface GlobalFilterDetails {
  DateDetails: GlobalFilterDateDetails;
}

export interface GlobalFilterState {
  value?: GlobalFilterDetails;
  status?: 'idle' | 'loading' | 'failed';
}
let filterKey: string | undefined;

// Should be called when  schema is set
const getFilterKey = () => {
  if (!filterKey) {
    filterKey = `${getUserSchema()}-global-filters`;
  }
  return filterKey;
};

export const getLocalStorageDates = () => {
  const localStorageData = getValueOrDefault<string>(localStorage.getItem(getFilterKey()), '{}');
  const dateDetails = getValueOrDefault(JSON.parse(localStorageData).DateDetails, '{}');
  return dateDetails;
};

const initialState: GlobalFilterState = {
  value: {
    DateDetails: {
      dateEnd: '',
      dateStart: '',
      quickDateRange: {
        value: '',
        text: '',
      },
    },
  },
};

export const globalFilterSlice = createSlice({
  name: 'globalFilter',
  initialState,
  reducers: {
    setGlobalDateFilters: (state, action) => {
      state.value = action.payload;
      localStorage.setItem(getFilterKey(), JSON.stringify(action.payload));
    },
    removeGlobalDateFilters: (state) => {
      state.value = undefined;
      localStorage.removeItem(getFilterKey());
    },
  },
});

export const { setGlobalDateFilters, removeGlobalDateFilters } = globalFilterSlice.actions;

export default globalFilterSlice.reducer;

export const selectSearchQuery = (state: RootState) => state.rootReducer.filter;
